import { SpotlightDocumentSchema } from "@redotech/redo-spotlight-common/spotlight-document-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTeamCheckoutProbabilitySpotlights = {
  name: "getTeamCheckoutProbabilitySpotlights" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(SpotlightDocumentSchema),
};
